import { getTime } from "core/utils/date";
export function getViewData(topPickWeek, day) {
    var today = topPickWeek.find(function (topPickDay) { return topPickDay.date === day; });
    if (!today) {
        return [];
    }
    return today.topPicks.map(topPickToTopPickCard);
}
function topPickToTopPickCard(topPick) {
    return {
        uuid: topPick.uuid,
        id: topPick.channel,
        program: topPick.program,
        title: topPick.title,
        airtime: getAirTime(Date.parse(topPick.from), Date.parse(topPick.to)),
        liveUrl: topPick.liveLink
            ? getLiveUrl(topPick.liveLink.url, Date.parse(topPick.from), Date.parse(topPick.to))
            : null,
        image: topPick.image,
        link: topPick.link ? topPick.link.url : null,
        kind: "TopPick",
        type: "TopPick",
        linkType: topPick.linkType
    };
}
function getLiveUrl(url, from, to) {
    var now = Date.now();
    return now >= from && now <= to ? url : null;
}
function getAirTime(from, to) {
    return "".concat(getTime(from), " - ").concat(getTime(to));
}
